import { values } from 'lodash';
import React, { Component } from 'react';
import Select from 'react-select';

export default class ItemFormCustomSelect extends Component {
  handleChange = values => {
    let value;
    if (values instanceof Array || this.props.isMulti) {
      value = this.detectUnselect(values)
        ? values.map(val => {
            return val.value;
          })
        : [];

      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    } else {
      value = values.value;
      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    }
    console.log('Return OnChange\n', 'Name : ', this.props.name, '\nValue : ', value);
    this.props.onChange(this.props.name, value);

    // if (this.props.name.includes('.')) {
    //   const fieldName = this.props.name.split('.')[0];
    //   const fieldName1 = this.props.name.split('.')[1];
    //   console.log('valuesvalues', this.props.values);
    //   let innerFieldsValue = this.props.values[fieldName];
    //   console.log(' ...values[fieldName], ...values[fieldName],', innerFieldsValue);
    //   innerFieldsValue[fieldName1] = values.value;
    //   console.log(' ...values[fieldName], ...values[fieldName],', innerFieldsValue);
    //   this.props.onChange([fieldName], innerFieldsValue);
    // } else {
    //   this.props.onChange([this.props.name], value);
    // }
  };
  detectUnselect = values => {
    if (!values || !values.length > 0) return false;
    for (let i = 0; i < values.length; i++) {
      if (!values[i].value) {
        return false;
      }
    }
    return true;
  };

  handleBlur = () => {
    this.props.onBlur([this.props.name], true);
  };

  render() {
    console.log('In Item custom select::', this.props);
    const { name, options, value, placeholder, isMulti } = this.props;
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
    };

    const valuesList = value
      ? Array.isArray(value)
        ? options.filter(option => value.includes(option.value))
        : options.filter(option => value.toString() === option.value.toString())
      : [];
    return (
      <Select
        name={name}
        isMulti={isMulti}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        value={valuesList}
        placeholder={placeholder}
        onChange={this.handleChange}
        styles={colourStyles}
      />
    );
  }
}
